/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown>, total: NonNullable<unknown> }} Step_OfInputs */



/**
* | output |
* | --- |
* | "Step {current} of {total}" |
*
* @param {Step_OfInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const step_of = /** @type {((inputs: Step_OfInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Step_OfInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Step ${i?.current} of ${i?.total}`)
	return /** @type {LocalizedString} */ (`Étape ${i?.current} sur ${i?.total}`)
});